// @flow

import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'

const Searching = styled.div`
  position: fixed;
  width: 100%;
  height: 100vh;
  margin-top: -44px;
  opacity: 0.3;
  background-color: ${Colors.white};
  z-index: 999;

  &[data-type='map'] {
    margin-top: 0;
    width: 312px;
  }
`

export default ({ SearchingViewType }) => (
  <div>
    <Searching data-type={SearchingViewType} />
  </div>
)



// WEBPACK FOOTER //
// ./src/components/organisms/SearchProgressModal/index.jsx